import { styled, Box, Typography } from "@mui/material";

export const STATUS_COLORS = [
  "free", // 0
  "essential", // 1
  "premium", // 2
  "proSuite", // 3
  "frozen", // 4
  "deleted", // 5
  "inactive", // 6
];

const BADGE_COLOR_PALETTE = {
  free: {
    light: "#DBE3FF", // blue/300
    main: "#6581E8", // blue/600
  },
  essential: {
    light: "#FFF4E3", // red/100
    main: "#F79A00", // red/600
  },
  premium: {
    light: "#F5DAF7", // green/100
    main: "#99439D", // green/600
  },
  proSuite: {
    light: "#D6FEF0", // orange/300
    main: "#29C18C", // orange/600
  },
  frozen: {
    light: "#E8F1FF", // grey/200
    main: "#0F52BA", // grey/600
  },
  deleted: {
    light: "#FFECE8", // grey/200
    main: "#F32A00", // grey/600
  },
  inactive: {
    light: "#E1E1E1",
    main: "#565556",
  },
};

const TEXT_VARIANT = {
  small: {
    fontSize: "11px",
  },
  medium: {
    fontSize: "12px",
  },
};

function getColorPaletteByStatus(statusNumber) {
  const statusKey = STATUS_COLORS[statusNumber];
  return BADGE_COLOR_PALETTE[statusKey];
}

export const BadgeContainer = styled(Box)(({ colorScheme }) => ({
  width: "max-content",
  height: "28px",
  padding: "4px 8px",
  borderRadius: "2px",
  // color: BADGE_COLOR_PALETTE[colorScheme]?.main,
  // backgroundColor: BADGE_COLOR_PALETTE[colorScheme]?.light,
  color: getColorPaletteByStatus(colorScheme)?.main,
  backgroundColor: getColorPaletteByStatus(colorScheme)?.light,
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const BadgeText = styled(Typography)(({ textVariant }) => ({
  fontWeight: 400,
  fontSize: TEXT_VARIANT[textVariant].fontSize,
  lineHeight: "20px",
  textTransform: "capitalize",
  fontFamily: "DM Sans",
}));

export const BadgeIcon = styled(Box)(({ isRotate }) => ({
  width: "16px",
  height: "16px",
  marginRight: "6px",

  ["> svg"]: {
    width: "100%",
    height: "100%",
  },

  "& .MuiSvgIcon-root": {
    rotate: isRotate ? "90deg" : "0deg",
  },
}));
